// CRA inlines REACT_APP_* at build time. `public/runtime-config.js` (window.__LOOP_RUNTIME_CONFIG__)
// is replaced per environment on the server, so the checkout can be switched on or off without a
// rebuild; each field it defines wins over the build. The checkout stays off (WhatsApp fallback)
// unless it is explicitly enabled and the Store API is configured; switching it off is the rollback.
const browserRuntime = () => (typeof window === 'undefined' ? undefined : window.__LOOP_RUNTIME_CONFIG__);

export function readCommerceConfig(env = process.env, runtime = browserRuntime()) {
    // A runtime file that defines something other than a plain object (null, "false", [] after a
    // hand edit) is treated as "checkout off", never as "use the build".
    const isPlainObject = runtime !== null && typeof runtime === 'object' && !Array.isArray(runtime);
    const rt = runtime === undefined ? {} : isPlainObject ? runtime : { commerceEnabled: false };
    const pick = (runtimeKey, envKey) => (typeof rt[runtimeKey] === 'string' ? rt[runtimeKey] : env[envKey] || '');

    const baseUrl = pick('medusaBackendUrl', 'REACT_APP_MEDUSA_BACKEND_URL').replace(/\/+$/, '');
    const publishableKey = pick('medusaPublishableKey', 'REACT_APP_MEDUSA_PUBLISHABLE_KEY');
    // Once the runtime file names the switch, only a literal `true` turns the checkout on: a
    // hand-edited "false", 0 or null must not leave an enabled build running.
    const switchedOn = 'commerceEnabled' in rt
        ? rt.commerceEnabled === true
        : env.REACT_APP_COMMERCE_ENABLED === 'true';
    return {
        enabled: switchedOn && Boolean(baseUrl && publishableKey),
        baseUrl,
        publishableKey,
        regionId: pick('medusaRegionId', 'REACT_APP_MEDUSA_REGION_ID'),
        countryCode: (pick('medusaCountryCode', 'REACT_APP_MEDUSA_COUNTRY_CODE') || 'br').toLowerCase(),
    };
}
